<template>
    <section id="profile" class="grid-section">
        <div class="content">
            <transition name="slide-left" mode="out-in">
                <div class="transition-wrapper" key="1" v-if="showExperience === false">
                    <h2 class="section-head">{{ sectionHeadlineProfile }}</h2>
                    <h2 class="section-subhead">{{ sectionIntroProfile }}</h2>
                    <div class="wrapper-go-to">
                        <div class="btn"><a @click="showExperience = true">Experience</a>
                            <div></div>
                        </div>
                    </div>
                    <div class="section-copy">
                        <p><strong>My Focus</strong> is on UX Design and Digital Art Direction. <strong>But I’m also</strong> a prospective developer, part time copywriter, occasional photographer & amateur sound designer. <strong>I speak</strong> german, english, JAVA, CSS and also understand a little french, C#, javascript.</p>
                        <br>
                        <p><strong>I always love</strong> to learn something new.</p>
                    </div>
                </div>
                <div class="wrapper-go-back" key="5" v-if="showExperience === true">
                    <div class="btn-back">
                        <div></div>
                        <a @click="showExperience = false">back</a>
                    </div>
                </div>
            </transition>
        </div>
        <div class="content-right">
            <transition name="slide-left" mode="out-in">
                <div class="transition-wrapper" key="3" v-if="showExperience === false">
                    <img id="portrait" src="@/assets/img/portrait_tobi-hoffmann.jpg"/>
                </div>
                <div class="experience" key="4" v-if="showExperience === true">
                    <h3>Experience</h3>
                    <ul>
                        <li>
                            <p>Senior Art Director Digital</p>
                            <div class="line"></div>
                            <p>2015 – 2017</p>
                        </li>
                        <li class="agency">Nordiskbüro</li>
                        <li>
                            <p>Art Director</p>
                            <div class="line"></div>
                            <p>2007 – 2014</p>
                        </li>
                        <li class="agency">Millemedia</li>
                        <li>
                            <p>Junior Art Director</p>
                            <div class="line"></div>
                            <p>2006 – 2007</p>
                        </li>
                        <li class="agency">DMGDW</li>
                        <li>
                            <p>Digital Media Deisgner</p>
                            <div class="line"></div>
                            <p>1999 – 2003</p>
                        </li>
                        <li class="agency">Grafikbüro Ehlers & Kaplan</li>
                    </ul>
                    <br><br>
                    <h3>Currently</h3>
                    <ul>
                        <li>
                            <p>studying computer science</p>
                            <div class="line"></div>
                            <p>2018 – now</p>
                        </li>
                        <li class="agency">HTW Berlin</li>
                    </ul>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Profile",
        props: {
            sectionHeadlineProfile: String,
            sectionIntroProfile: String,
        },
        data() {
            return {
                showExperience: false
            }
        }
    }
</script>

<style lang="css" scoped>

    .content a {
        cursor: pointer;
    }

    .section-copy {
        width: 50%;
        padding-top: 3rem;
        overflow: hidden;
    }

    .content-right {
        grid-column: 4 / 6;
        grid-row: 1 / 7;
        display: grid;
        grid-template-rows: repeat(6, 1fr);
        overflow: hidden;
    }

    #portrait {
        width: 100%;
        grid-row: 1 / 7;
    }

    .experience {
        grid-row: 2 / 7;
        line-height: 2rem;
        overflow: hidden;
        width: 100%;
    }

    .experience h3 {
        font-size: 1rem;
        font-weight: 600;
        margin-bottom: 2rem;
    }

    .experience li {
        display: flex;
        justify-content: space-between;
    }

    .agency {
        color: rgba(86, 86, 86, 0.5);
        margin-bottom: 2rem;
    }

    .line {
        flex-grow: 1;
        border-bottom: 1px solid rgba(57, 224, 151, 1);
        margin-left: 1rem;
        margin-right: 1rem;
        align-self: start;
        margin-top: 1rem;
    }

    #profile .section-subhead {
        padding-right: 5rem;
    }

    /*** SCREENS ***/

    /* Mobile: Portrait and Landscape */
    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 600px)
    and (-webkit-min-device-pixel-ratio: 2) {

        .section-copy {
            width: 100%;
        }

        #profile .section-subhead {
            padding-right: 0;
        }

        #portrait {
            display: none;
        }

        .content-right {
            display: block;
            grid-template-rows: repeat(6, 1fr);
            overflow: hidden;
        }
    }



</style>
